module.exports = __webpack_public_path__ + "static/img/fondo-login.5e6ca86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fondo-login.png
// module id = rAhu
// module chunks = 3